class ArcadeHome {
  constructor(supabaseClient) {
    this.baseUrl = supabaseClient.supabaseUrl;
    this.supabaseKey = supabaseClient.supabaseKey;
    
    this.init();
  }

  pad(num) {
    return String(num).padStart(2, '0');
  }

  updateDateTime() {
    const now = new Date();
    const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
      'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
    
    const dateStr = `${days[now.getDay()]} ${now.getDate()} ${months[now.getMonth()]}`;
    const timeStr = `${this.pad(now.getHours())}:${this.pad(now.getMinutes())}:${this.pad(now.getSeconds())}`;
    
    document.getElementById('date').textContent = dateStr;
    document.getElementById('time').textContent = timeStr;
  }

  formatScore(score) {
    return String(score);
  }

  async updateLeaderboard() {
    try {
      const response = await fetch(
        `${this.baseUrl}/functions/v1/game-core/global-leaderboard`,
        {
          headers: {
            'apikey': this.supabaseKey,
            'Authorization': `Bearer ${this.supabaseKey}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.json();
      
      if (result.code === 'OP_200' && result.data) {
        this.displayLeaderboard(result.data);
      } else {
        console.error('[Leaderboard] Invalid response:', result);
      }
    } catch (error) {
      console.error('[Leaderboard] Error fetching data:', error);
      document.getElementById('leaderboard').innerHTML =
        '<div class="loading" style="color: #ff4500;">Error loading leaderboard. Retrying...</div>';
    }
  }

  displayLeaderboard(data) {
    const container = document.getElementById('leaderboard');
    container.innerHTML = '';

    data.forEach((entry, index) => {
      const position = index + 1;
      const div = document.createElement('div');
      div.className = `entry rank-${position <= 3 ? position : 'other'}`;
      
      if (!entry.customer_name && entry.total_score === 0) {
        div.innerHTML = `
          <span class="position">${position}.</span>
          <span class="player-name" style="color: #555;">---</span>
          <span class="score" style="color: #555;">- --------</span>
        `;
      } else {
        const playerName = entry.customer_name
          ? `@${entry.customer_name.toUpperCase()}`
          : '@UNKNOWN';
        const score = this.formatScore(entry.total_score);
        
        div.innerHTML = `
          <span class="position">${position}.</span>
          <span class="player-name">${playerName}</span>
          <span class="score">- ${score}</span>
        `;
      }
      
      container.appendChild(div);
    });
  }

  init() {
    this.updateDateTime();
    this.updateLeaderboard();
    
    // Arrow functions per mantenere il contesto di 'this'
    setInterval(() => this.updateDateTime(), 1000);
    setInterval(() => this.updateLeaderboard(), 60000);
  }
}